// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusProg50Icon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path fill="currentColor" d="M12 3a9 9 0 0 1 0 18V3" />
  </svg>,
  "StatusProg50",
);
export default StatusProg50Icon;
